'use client';

import { FC, useEffect } from 'react';
import { useSurfsideContext } from '@surfside/ads-react';

import { useEcomStoreSelector } from '@/data';

/**
 * Keeps Surfside provider location in sync with the selected Treez store.
 * Provider may start with locationId undefined until the store is known.
 */
export const SurfsideLocationSync: FC = () => {
  const { treez_store_name } = useEcomStoreSelector(['treez_store_name']);
  const { setLocationId } = useSurfsideContext();

  useEffect(() => {
    if (treez_store_name) {
      setLocationId(treez_store_name);
    }
  }, [setLocationId, treez_store_name]);

  return null;
};
